import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "linkedin-net-followers-card card mb-4 border-0 border-radius d-block bg-white border-0 shadow-none" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "trezo-card-header d-sm-flex align-items-center justify-content-between" }
const _hoisted_4 = { class: "trezo-card-subtitle" }
const _hoisted_5 = { class: "trezo-card-header-menu position-relative" }
const _hoisted_6 = { class: "trezo-card-content" }
const _hoisted_7 = { class: "chart" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "trezo-card-title" }, [
          _createElementVNode("h5", { class: "mb-0 fw-semibold" }, "LinkedIn Net Followers"),
          _createElementVNode("p", { class: "fw-normal" }, [
            _createTextVNode(" Net followers growth: "),
            _createElementVNode("span", { class: "text-primary" }, "+275")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("select", {
              class: "form-select month-select form-control",
              "aria-label": "Default select example",
              onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleTimeRangeChange && _ctx.handleTimeRangeChange(...args)))
            }, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("option", { value: "Last Day" }, "Last Day", -1),
              _createElementVNode("option", { value: "Last Week" }, "Last Week", -1),
              _createElementVNode("option", { value: "Last Month" }, "Last Month", -1),
              _createElementVNode("option", { value: "Yearly" }, "Last Year", -1)
            ]))], 32)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[3] || (_cache[3] = _createStaticVNode("<ul class=\"funfacts-list d-sm-flex align-items-center p-0 m-0 list-unstyled\" data-v-2320b952><li data-v-2320b952><span class=\"fw-medium text-black\" data-v-2320b952> 56,100 </span><span class=\"d-block text-xs\" data-v-2320b952> Starting Followers </span></li><li data-v-2320b952><span class=\"fw-medium text-black\" data-v-2320b952> 300 </span><span class=\"d-block text-xs\" data-v-2320b952> New Followers </span></li><li data-v-2320b952><span class=\"fw-medium text-black\" data-v-2320b952> 25 </span><span class=\"d-block text-xs\" data-v-2320b952> Unfollows </span></li><li data-v-2320b952><span class=\"fw-medium text-black\" data-v-2320b952> 56,375 </span><span class=\"d-block text-xs\" data-v-2320b952> Ending Followers </span></li></ul>", 1)),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.isClient)
            ? (_openBlock(), _createBlock(_component_apexchart, {
                key: 0,
                type: "area",
                height: "298",
                options: _ctx.netFollowers,
                series: _ctx.followers,
                ref: "chart"
              }, null, 8, ["options", "series"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}